export function authHeader() {
  // return authorization header with jwt token
   const token = localStorage.getItem("userToken");
if(token){
  let AdminUser = JSON.parse(token);
  if (AdminUser && AdminUser.accessToken) {
    var allowedOrigins = "*";
    var allow_headers =
      "Referer,Accept,Origin,User-Agent,Content-Type,Authorization";
    return {
      Authorization: "Bearer " + AdminUser.accessToken,
      "Content-Type": "application/json, multipart/form-data",
      "Access-Control-Allow-Origin": allowedOrigins,
      "Access-Control-Allow-Methods": "PUT,GET,POST,DELETE,OPTIONS",
      // "Access-Control-Allow-Headers": "Content-Type, Authorization",
      "Access-Control-Allow-Headers": allow_headers,
      "WWW-Authenticate": "Basic",
      "Access-Control-Allow-Credentials": true,
    };
  }
 }
}
export function golangHeader() {
  const token = localStorage.getItem("userToken");
  if(token){
  let AdminUser = JSON.parse(token);
  return {
    Authorization: "Bearer " + AdminUser.accessToken,
    "Content-Type": "application/json",
  };
 }
}
